import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
   
    useEffect(() => {
        document.title = process.env.REACT_APP_PROJECT_SORT_NAME+"-Dashboard";  
      }, []);
    return (
        <div className='bg-slate-100 min-h-[calc(100vh_-_4rem)] ml-0'>
            Dashboard 2<br/>
            <Link to="/settings">Setting</Link>
        </div>
    );
}

export default Dashboard;
